import axios from 'axios'
import { BASE_URL } from "./baseUrl";

export const countRequest = async(data, locale) => {
 const res = await axios.post(`${BASE_URL}/calc/result`, {
   data: {
     countryCodeFrom: data.countryCodeFrom,
     postCodeFrom: data.postCodeFrom,
     postCodeTo: data.postCodeTo,
     cityFrom: data.cityFrom,
     cityTo: data.cityTo,
     totalKg: data.totalKg,
     totalVolume: data.totalVolume,
     locale: locale,
   },
 });
return res.data
}
